module.exports = __webpack_public_path__ + "fonts/StagSans-Black-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Black-Italic.otf
// module id = 1097
// module chunks = 0